/**
 * Add chart data styling based on spectrum metadata
 * @param data - Data object to style
 * @param spectrum - Spectrum with metadata
 */
export function addChartDataStyle(data, spectrum) {
    data.styles = {
        unselected: {
            lineColor: spectrum.meta.color || 'darkgrey',
            lineWidth: 1,
            lineStyle: 1,
        },
        selected: {
            lineColor: spectrum.meta.color || 'darkgrey',
            lineWidth: 3,
            lineStyle: 1,
        },
    };
    data.label = spectrum.meta.id || String(spectrum.id);
}
//# sourceMappingURL=addChartDataStyle.js.map